import axios from 'axios';

const api = axios.create({
    baseURL: 'https://zotpot.in/public/api/',
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});

export default api;